/*************************************************************************
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
// using keycodes instead of code
// for dom events because it is not cross
// browser compatible

export const ARROW_LEFT = 37;
export const ARROW_RIGHT = 39;
export const ARROW_UP = 38;
export const ARROW_DOWN = 40;
export const PAGE_UP = 33;
export const PAGE_DOWN = 34;
export const HOME = 36;
export const END = 35;
export const PLUS = 187; // Different in FF
export const MINUS = 189; // Different in FF
export const FF_PLUS = 61;
export const FF_MINUS = 173;
export const NUMPAD_PLUS = 107;
export const NUMPAD_MINUS = 109;
export const ZERO = 48;
export const NUMPAD_ZERO = 45;
export const SPACE = 32;
export const TAB = 9;
export const BACKSPACE = 8;
export const DELETE = 46;

export const C = 67;
export const P = 80;
export const X = 88;
export const V = 86;
export const B = 66;
export const I = 73;
export const U = 85;
export const L = 76;
export const R = 82;
export const E = 69;
export const J = 74;
export const Z = 90;
export const Y = 89;
export const S = 83;

export const F = 70;
export const G = 71;
export const F3 = 114;
export const F6 = 117;
export const ENTER = 13;
export const ESCAPE = 27;
export const A = 65;
